import { useCallback, useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import {
  FilterOptionSelectedValue,
  FilterSelectedValue,
} from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { useAppAsyncFilterOptions } from '../../../../hooks/filters/use-app-filter-options.hook';
import { getIdClassNameHelper } from '../../helpers/get-id-class-name.helper';
import { hasFilterSelectedValue } from '../../hooks/common.hook';
import { FilterComponentProps } from '../../interfaces/filter-component-props.interface';
import './filter-tab-button.component.scss';

export interface FilterTabButtonBasicOnSelectProps
  extends FilterComponentProps {
  onSelect?(selectedValue?: FilterSelectedValue): void;
}

export interface FilterTabButtonBasicComponentProps
  extends FilterTabButtonBasicOnSelectProps {
  setSelectedValue: (selectedValue: FilterSelectedValue) => void;
  selectedValue: FilterSelectedValue | undefined;
  onSelect?(selectedValue?: FilterSelectedValue): void;
}

export const FilterTabButtonBasicComponent = ({
  filter,
  filterSelection,
  selectedValue,
  setSelectedValue,
  onSelect,
}: FilterTabButtonBasicComponentProps) => {
  const { options } = useAppAsyncFilterOptions(
    filter.id,
    filterSelection,
    null,
  );
  const [, setError] = useState<string | null>(null);
  const [key, setKey] = useState('');

  useEffect(() => {
    if (selectedValue) {
      const val = hasFilterSelectedValue(selectedValue);
      if (val) setKey(val.values[0].value);
    }
  }, [selectedValue]);

  const changeValueHandler = useCallback(
    (selectedOptionValue: FilterOptionSelectedValue) => {
      if (selectedValue) {
        const values = [
          {
            value: selectedOptionValue.value,
            label: selectedOptionValue.label,
          },
        ];
        const val: FilterSelectedValue = { ...selectedValue, values };
        if (filter.required && values.length === 0) {
          setError('Required');
        } else {
          setError(null);
          setSelectedValue(val);
          if (onSelect) {
            onSelect(val);
          }
        }
      }
    },
    [selectedValue, filter.required, setSelectedValue, onSelect],
  );

  return (
    <Nav
      className={`${getIdClassNameHelper(filter.id)} filter-tab-button`}
      variant="underline"
      defaultActiveKey={key}
    >
      {options.map((i) => (
        <Nav.Item key={i.value} onClick={() => changeValueHandler(i)}>
          <Nav.Link active={key === i.value}>{i.label}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};
